import { MenuItem } from '../dtos/menu-item';
import { CanvasPermissions } from '@canvas/four-r-digital';
import {
  faCertificate,
  faChartDiagram,
  faClockRotateLeft,
  faFileExcel,
  faFlask,
  faMoneyBill,
  faPerson,
  faQuestion,
  faUser,
} from '@fortawesome/free-solid-svg-icons';

const transactionsMenuItem: MenuItem = {
  label: 'Transactions',
  url: '/main/accounts/transactions',
  icon: faMoneyBill,
  permission: CanvasPermissions.AccountsView,
};

const entitiesMenuItem: MenuItem = {
  label: 'Entities',
  url: '/main/entities',
  icon: faPerson,
  permission: CanvasPermissions.EntityView,
};

const projectsMenuItem: MenuItem = {
  label: 'Projects',
  url: '/main/projects',
  icon: faChartDiagram,
  permission: CanvasPermissions.ProjectView,
};

const certificatesMenuItem: MenuItem = {
  label: 'Certificates',
  url: '/main/certificates',
  icon: faCertificate,
  permission: CanvasPermissions.CertificateView,
};

const usersMenuItem: MenuItem = {
  label: 'Users',
  url: '/main/users',
  icon: faUser,
  permission: CanvasPermissions.UsersView,
};

const exportMenuItem: MenuItem = {
  label: 'Export Transactions',
  url: '/main/export',
  icon: faFileExcel,
  permission: CanvasPermissions.AccountsView,
};

const surveysMenuItem: MenuItem = {
  label: 'Surveys',
  url: '/main/survey',
  icon: faQuestion,
  permission: CanvasPermissions.SurveyView,
};

const auditMenuItem: MenuItem = {
  label: 'Audit Log',
  url: '/main/audit',
  icon: faClockRotateLeft,
  permission: CanvasPermissions.AuditView,
};

export const paymentSimulatorMenuItem: MenuItem = {
  label: 'Payment Simulator',
  url: '/main/test/payment-simulator',
  icon: faFlask,
};

export const core = {
  transactionsMenuItem,
  entitiesMenuItem,
  projectsMenuItem,
  certificatesMenuItem,
  usersMenuItem,
  exportMenuItem,
  surveysMenuItem,
  auditMenuItem,
};
